import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { TagsProps } from 'components/uiKit/CheckableTag'
import CheckableTag from 'components/uiKit/CheckableTag'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldTag: React.FC<IControlProps<TagsProps<string>>> = ({ name, onChange, ...rest }) => {
  const handleChange = useCallback((value: string[]) => onChange({ value, name }), [name, onChange])

  return <CheckableTag name={name} onChange={handleChange} {...rest} />
}

export default FieldTag
